import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  setDisplayName,
} from 'recompose';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { get, noop, isEmpty } from 'lodash';
import qs from 'qs';
import immutableToJS from 'helpers/immutableToJS';
import { dispatchRestMaker } from 'helpers/utils';
import {
  AddSourceDialog,
  SmartDialog,
  injectIntl,
} from 'components';
import sellersActions, { sellersAcceptActions } from 'redux/sellers/actions';
import {
  selectState,
} from 'redux/selectors';
import PersonAddIcon from '@material-ui/icons/PersonAdd';

const styles = () => ({
  button: {
    backgroundColor: '#4695ec',
    borderRadius: 5,
    marginBottom: 10,
  },
  buttonLabel: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: 500,
    textTransform: 'initial'
  },
});

class AddVendorButton extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isConsumer: PropTypes.bool,
  };

  static propTypes = {
    vendorAccount: PropTypes.shape({
      id: PropTypes.number,
    }).isRequired,
    classes: PropTypes.shape({}).isRequired,
    formatMessage: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    sellerRequesting: PropTypes.bool.isRequired,
    seller: PropTypes.shape({}).isRequired,
    createSeller: PropTypes.func.isRequired,
    readSeller: PropTypes.func.isRequired,
    createSellersAccept: PropTypes.func.isRequired,
  };

  state = {
    vendorModalOpen: false,
    errorModalOpen: false,
  };

  componentWillMount() {
    const { currentUser } = this.context;
    const { vendorAccount, readSeller, history } = this.props;
    if (currentUser && currentUser.id && vendorAccount.id) {
      readSeller(vendorAccount.id);
      const { popup } = qs.parse(window.location.search.slice(1));
      this.setState({ vendorModalOpen: popup });
      history.push(window.location.pathname);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { currentUser } = this.context;
    const { vendorAccount, readSeller } = this.props;
    if (currentUser && currentUser.id && !vendorAccount.id && nextProps.vendorAccount.id) {
      readSeller(nextProps.vendorAccount.id);
    }
  }

  getButtonInfo = () => {
    const { currentUser } = this.context;
    const {
      vendorAccount,
      formatMessage,
      history: {
        push,
      },
      seller,
    } = this.props;

    const authRoleId = currentUser.roleId;
    const vendorRoleId = vendorAccount.currentRoleId;
    const signInLabel = isEmpty(currentUser) ? formatMessage('Sign-in or Sign-up to ') : '';
    const defaultLabel = signInLabel + formatMessage('Send ') + vendorAccount.profile.companyName + formatMessage(' a customer request');

    // If not logged in
    if (!currentUser.id) {
      return {
        label: defaultLabel,
        errorContent: (
          <div>
            <p>
              {vendorRoleId === 3
                ? 'TO ADD A DISTRIBUTOR AS A VENDOR ON FRESHr, SIGN-UP AS A BUYER ORGANIZATION'
                : 'TO ADD A FARM AS A VENDOR ON FRESHr, SIGN-UP AS A BUYER OR DISTRIBUTOR ORGANIZATION'}
            </p>
            <div className="d-flex justify-content-center">
              <Button
                onClick={() => push('/#signup')}
                variant="contained"
              >
                Go to Sign Up
              </Button>
            </div>
          </div>
        ),
        onClick: this.handleOpenErrorModal,
      };
    }

    // If personal account
    if (!authRoleId) {
      return {
        label: defaultLabel,
        errorContent:
          vendorRoleId === 3
            ? 'ADDING A DISTRIBUTOR AS A VENDOR REQUIRES A BUYER ORGANIZATION ACCOUNT ON FRESHr'
            : 'ADDING A FARM AS A VENDOR REQUIRES A BUYER OR DISTRIBUTOR ORGANIZATION ACCOUNT ON FRESHr',
        onClick: this.handleOpenErrorModal,
      };
    }

    // If farm account
    if (authRoleId === 4) {
      return {
        label: defaultLabel,
        errorContent: 'ADDING A VENDOR REQUIRES A BUYER ORGANIZATION ACCOUNT ON FRESHr',
        onClick: this.handleOpenErrorModal,
      };
    }

    // Distributor to distributor
    if (authRoleId === 3 && vendorRoleId === 3) {
      return {
        label: defaultLabel,
        errorContent: 'ATTENTION: A DISTRIBUTOR CAN NOT ADD ANOTHER DISTRIBUTOR ON FRESHr',
        onClick: this.handleOpenErrorModal,
      };
    }

    // Not connected
    if (!seller.id) {
      return {
        label: defaultLabel,
        onClick: this.handleOpenVendorModal,
      };
    }

    // Blocked or was blocked
    if (seller.isDeleted) {
      if (seller.requestorId === currentUser.accountId) {
        return {
          label: formatMessage('Unblock'),
          onClick: this.unblock,
        };
      }

      return {
        label: formatMessage('Blocked'),
        disabled: true,
      };
    }

    // Pending
    if (!seller.isDeleted && seller.requestorId) {
      if (seller.requestorId === currentUser.accountId) {
        return {
          label: formatMessage('Pending'),
          disabled: true,
        };
      }

      return {
        label: formatMessage('Accept'),
        onClick: this.acceptInvite,
      };
    }

    return {
      label: formatMessage('Connected'),
      disabled: true,
    };
  }

  handleOpenErrorModal = () => {
    const {
      history: {
        push,
        location,
      },
      vendorAccount,
    } = this.props;

    const vendorEmail = vendorAccount ? get(vendorAccount, 'email') : '';
    const profilePathname = location.pathname && location.pathname.split('/').length > 1 ? `/?profileUrl=${encodeURIComponent(location.pathname.split('/')[1])}` : '';
    const vendorEmailPathname = vendorEmail ? `&vendorEmail=${vendorEmail}` : '';
    if (profilePathname && vendorEmailPathname) {
      const pathname = `${profilePathname}${vendorEmailPathname}#signup`;
      push(pathname);
    } else {
      this.setState({ errorModalOpen: true });
    }
  }

  handleCloseErrorModal = () => {
    this.setState({ errorModalOpen: false });
  }

  handleOpenVendorModal = () => {
    const { isConsumer } = this.context;
    const { vendorAccount } = this.props;
    if (isConsumer) {
      const vendor = { email: vendorAccount.email };
      this.addVendor(vendor);
    } else {
      this.setState({ vendorModalOpen: true });
    }
  }

  handleCloseVendorModal = () => {
    this.setState({ vendorModalOpen: false });
  }

  addVendor = (data) => {
    this.props.createSeller({
      ...data,
      onSuccess: () => {
        this.setState({
          vendorModalOpen: false,
        });
        if (data.onSuccess) {
          data.onSuccess();
        }
      },
    });
  }

  acceptInvite = () => {
    const { vendorAccount } = this.props;

    this.props.createSellersAccept(vendorAccount.id, {
      onSuccess: () => {
        this.props.readSeller(vendorAccount.id);
      },
    });
  }

  unblock = () => {
    const { vendorAccount } = this.props;

    this.props.createSeller({
      companyName: get(vendorAccount, 'profile.companyName'),
      email: get(vendorAccount, 'email'),
      firstName: get(vendorAccount, 'profile.firstName'),
      lastName: get(vendorAccount, 'profile.lastName'),
    });
  }

  render() {
    const {
      classes,
      formatMessage,
      sellerRequesting,
      vendorAccount,
    } = this.props;

    if (sellerRequesting) {
      return <CircularProgress />;
    }

    const {
      vendorModalOpen,
      errorModalOpen,
    } = this.state;
    const {
      label,
      disabled = false,
      errorContent = '',
      onClick = noop,
    } = this.getButtonInfo();
    const sourceProps = {
      companyName: get(vendorAccount, 'profile.companyName'),
      email: get(vendorAccount, 'email'),
      firstName: get(vendorAccount, 'profile.firstName'),
      lastName: get(vendorAccount, 'profile.lastName'),
      selected: true,
    };

    return (
      <Fragment>
        <Button
          classes={{
            label: classes.buttonLabel,
            root: classes.button,
          }}
          disabled={disabled}
          onClick={onClick}
          variant="contained"
        >
        <PersonAddIcon style={{ marginRight: '3px', fontSize:'18px' }}/> {label}
        </Button>
        <AddSourceDialog
          createItem={this.addVendor}
          isVendor
          onClose={this.handleCloseVendorModal}
          info={sourceProps}
          open={vendorModalOpen}
          title={formatMessage(`Connect With ${sourceProps.companyName}`)}
          saveButtonTitle={formatMessage('Send request as a customer')}
        />
        <SmartDialog
          closeButtonOnTop
          onClose={this.handleCloseErrorModal}
          open={errorModalOpen}
          title={formatMessage('Error')}
        >
          <div style={{ color: 'red' }}>
            {errorContent}
          </div>
        </SmartDialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  ...selectState('sellers', 'seller')(state, 'seller'),
});

export default compose(
  setDisplayName('AddVendorButton'),
  connect(
    mapStateToProps,
    dispatchRestMaker([
      [sellersActions, 'seller'],
      [sellersAcceptActions, 'sellersAccept'],
    ]),
  ),
  immutableToJS,
  injectIntl,
  withRouter,
  withStyles(styles),
)(AddVendorButton);
